import ViewContainer from './container'
import MediumContainer from 'components/MediumContainer'
import { StyledPrivacyPolicyWrapper } from './styles'
import { Spin } from 'antd'

export default function Index () {
  return (
    <ViewContainer>
      {({ states }) => (
        <MediumContainer>
          <Spin spinning={states.legalTerms.status === 1}>
            <StyledPrivacyPolicyWrapper>
              <div dangerouslySetInnerHTML={{ __html: states.legalTerms.payload?.results[0]?.content }} />
            </StyledPrivacyPolicyWrapper>
          </Spin>
        </MediumContainer>
      )}
    </ViewContainer>
  )
}
